export default `<div>
    <p class="img"><img src="/storage/app/media/uploaded-files/eda576f4aeba575faa1094ef041416f.png"
            style="width: 300px;" class="fr-fic fr-dib" data-result="success"></p>

    <p>Founded in 2016, WeLion New Energy is a national high-tech enterprise focusing on the R&amp;D and production of
        solid-state lithium batteries, with a series of core patented technologies. Focusing on high energy density,
        high safety, high power, wide temperature range and long-life solid-state battery products, the company has been
        the first to complete the world's first solid-state lithium-ion prototype vehicle and released the first
        solid-state lithium-ion battery product with a range of 1000 km with strategic car manufacturers. As of now, the
        company has 4 production bases in Fangshan, Beijing, Liyang, Jiangsu, Huzhou, Zhejiang and Zibo, Shandong.&nbsp;
    </p>

    <p>WeLion New Energy has strategically entered the automotive and energy storage fields, focusing on high range
        power batteries and high safety energy storage batteries. In terms of R&amp;D, the company has applied for more
        than 400 national patents and authorized more than 100, including core materials and technologies such as
        composite cathode, solid electrolyte, diaphragm and cathode of solid-state batteries, forming an intellectual
        property system. In terms of industrialization, the company has entered into cooperation with many domestic and
        international OEMs such as NIO and Geely. Among them, the hybrid solid-liquid electrolyte battery with NIO is
        expected to start mass production by the end of this year or the first half of next year, and the battery can
        have a range of 1000 km on a single charge.</p>

</div>`;
